import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ParadigmaModal from "../../../components/ParadigmaModal/ParadigmaModal.js"
import api from "../../../api";

import { Row, Col, Label, Input, InputGroup, FormFeedback } from 'reactstrap';

import ParadigmaAsyncSeeker from "../../../components/ParadigmaAsyncSeeker/ParadigmaAsyncSeeker.js"
import ParadigmaLabeledInput from "../../../components/ParadigmaLabeledInput/ParadigmaLabeledInput.js"

class Avanzar extends Component {
    constructor(props) {
        super(props);
        this.state = {
            solicitud: null,
        };
    }

    static propTypes = {
        onSubmit: PropTypes.func.isRequired,
        id: PropTypes.func.isRequired,
    }

    setSelects(data) {
        this.setState({
            solicitud: data.solicitud_id,
            proyecto_codigo: data.codigo,
        });
    }

    render() {
        return (
            <ParadigmaModal
                getUrl={api.proyectos.presupuesto.avanzar}
                postUrl={api.proyectos.presupuesto.avanzar}
                onSubmit={() => this.props.onSubmit()}
                id={this.props.id}
                successMessage={"El Proyecto está listo para generar el Informe."}
                missingIdMessage={"Debe seleccionar una fila."}
                notAllowedMessage={"El Proyecto ya fue avanzado a la etapa de generación de Informe."}
                title={"Generar Informe"}
                buttonTitle={"Generar Informe"}
                buttonIcon={"fa fa-file fa-lg"}

                saveButton={true}
                closeButton={true}
                buttonClass={"btn-success btn-next"}
                onGotData={(data) => this.setSelects(data)}>
                
                <ParadigmaLabeledInput
                    label={"Nº Presupuesto"}
                    labelColumns={3}
                    fieldColumns={9}
                    inputComponent={<ParadigmaAsyncSeeker pkField={"codigo"} nombreField={"cod"} fieldName={""}
                        url={api.proyectos.solicitudes.selectcodigo} value={this.state.proyecto_codigo} disabled={true} />}
                />

                <ParadigmaLabeledInput
                    label={"Proyecto"}
                    labelColumns={3}
                    fieldColumns={9}
                    inputComponent={<ParadigmaAsyncSeeker fieldName={"solicitud_id"} url={api.proyectos.solicitudes.select}
                        value={this.state.solicitud} disabled={true} />}
                />
            </ParadigmaModal>
        );
    }
}

export default Avanzar;



// WEBPACK FOOTER //
// ./src/views/Proyectos/Procedimiento3/Avanzar.js